import ResponseEntity, { InputEntity } from "../../..";
import { IsBoolean, IsInt, IsNumber, IsString } from "class-validator";

export default class TransmedFormField extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @IsString() public readonly title!: string;
  @IsString() public readonly subtitle!: string;

  @IsNumber({ allowInfinity: false, allowNaN: false })
  public readonly points!: number;

  @IsBoolean() public readonly quantitative!: boolean;
  @IsString() public readonly unit_singular!: string;
  @IsString() public readonly unit_plural!: string;
}

export class TransmedFormFieldInput extends InputEntity {
  public constructor(
    public readonly title: string,
    public readonly subtitle: string,
    public readonly points: number,
    public readonly quantitative: boolean,
    public readonly unit_singular: string,
    public readonly unit_plural: string,
    public readonly subsection: number
  ) {
    super();
  }
}